import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'

import Button from 'ant-design-vue/lib/button'
import Col from 'ant-design-vue/lib/col'
import Menu from 'ant-design-vue/lib/menu'
import Row from 'ant-design-vue/lib/row'
import Layout from 'ant-design-vue/lib/layout'
import { Form } from 'ant-design-vue'
import 'ant-design-vue/lib/button/style'
import 'ant-design-vue/lib/col/style'
import 'ant-design-vue/lib/menu/style'
import 'ant-design-vue/lib/row/style'
import 'ant-design-vue/lib/layout/style'
import 'ant-design-vue/lib/form/style'
import './main.less'

Vue.config.productionTip = false

Vue.use(VueViewer)
Vue.use(Button)
Vue.use(Col)
Vue.use(Menu)
Vue.use(Row)
Vue.use(Layout)
Vue.component(Form.name, Form)
Vue.component(Form.Item.name, Form.Item)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
